/**
 * Mapping of Learn-screen section ids → the article tags that make up that
 * section. Single source of truth used by LearnScreen (to build sections)
 * and ArticleDetailScreen (to show "next in section" siblings when an
 * article is opened from a known section via the `?utm_source=` query param).
 */
import type { ContentTag } from "@louise/content";

export const SECTION_TAGS: Record<string, ContentTag[]> = {
  guides: ["moon-guides"],
  travel: ["travel"],
  decisions: ["moon-decisions"],
  science: ["moon-science"],
  costs: ["moon-costs"],
  conditions: [
    "endo",
    "pcos",
    "thyroid",
    "clinic-visit",
    "sperm",
    "semen-analysis",
    "age-factor",
    "genetic-screening",
  ],
  treatments: ["during-cycle", "pre-cycle", "egg-freezing", "post-cycle"],
  lifestyle: ["lifestyle", "optimization"],
  support: ["emotional"],
};

export function getTagsForSection(sectionId: string): ContentTag[] | null {
  return SECTION_TAGS[sectionId] ?? null;
}
